import { ReactNode } from "react";

import Box from "ds/components/Box";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import { DocsUrl } from "utils/getDocsUrl";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import PageInfoHeaderActions from "ds/components/PageInfoHeader/Actions";
import PageInfoHeaderCaption from "ds/components/PageInfoHeader/Caption";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";

type StackSettingsPageLayoutProps = {
  children: ReactNode;
  title: string;
  description?: string;
  readMoreDocsLink?: DocsUrl;
  navigation?: ReactNode;
  actions?: ReactNode;
};

const StackSettingsPageLayout = ({
  children,
  title,
  description,
  readMoreDocsLink,
  navigation,
  actions,
}: StackSettingsPageLayoutProps) => {
  return (
    <Box direction="column" grow="1">
      <PageInfoHeaderWrapper align="start">
        <Box direction="column">
          <PageInfoHeaderTitle title={title} />

          {description && (
            <PageInfoHeaderCaption
              caption={
                <>
                  {description}
                  {readMoreDocsLink && (
                    <>
                      {" "}
                      <ReadMoreDocsLink docsUrl={readMoreDocsLink} />
                    </>
                  )}
                </>
              }
            />
          )}
          {navigation && <ViewHeaderNavigation>{navigation}</ViewHeaderNavigation>}
        </Box>

        {actions && <PageInfoHeaderActions>{actions}</PageInfoHeaderActions>}
      </PageInfoHeaderWrapper>

      {children}
    </Box>
  );
};

export default StackSettingsPageLayout;
